import { Dayjs } from 'dayjs';

import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';

export interface AddManualScanFormValues {
  date: Dayjs;
  status: Quality_SegmentHistoryStatusEnum_Enum;
  zone: string;
  ringId: string;
}

export interface FormSelectOption {
  label: string | number;
  value: string;
}

export const ERROR_MAPPING: Record<string, string> = {
  'missing-ring-number': 'missingRingNumber',
  'ring-complete': 'ringComplete',
  'duplicate-segment-type': 'duplicateSegmentType',
};

export const ReceiptStatuses = [
  Quality_SegmentHistoryStatusEnum_Enum.Quarantine,
  Quality_SegmentHistoryStatusEnum_Enum.Accepted,
  Quality_SegmentHistoryStatusEnum_Enum.Rejected,
];
export const TunnelStatuses = [Quality_SegmentHistoryStatusEnum_Enum.Installed];

export const OrderedStatuses = [
  Quality_SegmentHistoryStatusEnum_Enum.Imported,
  Quality_SegmentHistoryStatusEnum_Enum.OnHold,
  Quality_SegmentHistoryStatusEnum_Enum.Quarantine,
  Quality_SegmentHistoryStatusEnum_Enum.Accepted,
  Quality_SegmentHistoryStatusEnum_Enum.Rejected,
  Quality_SegmentHistoryStatusEnum_Enum.TunnelRejected,
  Quality_SegmentHistoryStatusEnum_Enum.Installed,
];

export const ScanStatusDeletable = [
  Quality_SegmentHistoryStatusEnum_Enum.OnHold,
  Quality_SegmentHistoryStatusEnum_Enum.Quarantine,
  Quality_SegmentHistoryStatusEnum_Enum.Accepted,
  Quality_SegmentHistoryStatusEnum_Enum.Rejected,
  Quality_SegmentHistoryStatusEnum_Enum.TunnelRejected,
  Quality_SegmentHistoryStatusEnum_Enum.Installed,
];

export const StatusesEditableByBulk = [
  Quality_SegmentHistoryStatusEnum_Enum.Accepted,
  Quality_SegmentHistoryStatusEnum_Enum.Rejected,
  Quality_SegmentHistoryStatusEnum_Enum.OnHold,
];
